import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PrimaryImage from './wire-view-components/primary-image';
import DummyImage from './wire-view-components/dummy-image';
import Description from './wire-view-components/description';
import MentionMissingImage from './wire-view-components/mention-missing-image';

const Container = styled.div`
  display: flex;
  margin-bottom: 32px;
  flex-direction: ${props => (props.theme.isMobile ? 'column' : 'row')};

  & > *:first-child {
    margin: ${props => (props.theme.isMobile ? '16px 0' : '0 16px 0 0')};
  }
`;

export default function WireView(props) {
  const { wire } = props;
  const isOwnWire = wire.profileId === props.profileId;
  return (
    <Container>
      {wire.primaryImageUrl && (<PrimaryImage {...wire} />)}
      {!wire.primaryImageUrl && isOwnWire && (
        <DummyImage wireId={wire.id} slug={wire.slug} />
      )}
      {!wire.primaryImageUrl && !isOwnWire && (
        <MentionMissingImage {...wire} />
      )}
      {(wire.primaryImageUrl || isOwnWire) && (
        <Description {...wire} />
      )}
    </Container>
  );
}

WireView.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    profileId: PropTypes.number.isRequired,
    contributor: PropTypes.shape({
      name: PropTypes.string.isRequired,
      organization: PropTypes.string,
    }).isRequired,
    primaryImageUrl: PropTypes.string,
    removable: PropTypes.bool,
  }),
  profileId: PropTypes.number.isRequired,
};

WireView.defaultProps = {
  wire: {
    primaryImageUrl: null,
    removable: false,
  },
};
